import { createSystemContextPorts } from '../app/system_runtime_context.js';
import { createPlanQueryProviderService } from './plan_query_provider_service.mjs';
import { getRenderSceneInvalidationState, subscribeRenderSceneInvalidation } from '../render/render_scene_invalidation.mjs';

const contextPorts = createSystemContextPorts(() => false);
// Registration is cheap. A future viewport requests data explicitly, outside pointer moves.
const queries = createPlanQueryProviderService({
  getContext() {
    const current = contextPorts.current();
    if (!current?.projectToken || !current.sheetId || !current.view) return null;
    const invalidation = getRenderSceneInvalidationState();
    return { projectToken: current.projectToken, sheetId: current.sheetId, view: current.view,
      epoch: invalidation.epoch, modelRevision: current.revision,
      geometryRevision: invalidation.geometryRevision, assetRevision: invalidation.geometryRevision };
  },
  onError(issue) { console.warn(`[plan-query] ${issue.owner}: ${issue.code}`); }
});
subscribeRenderSceneInvalidation(() => queries.synchronizeContext());

export const registerPlanQueryProvider = queries.registerProvider;
export const unregisterPlanQueryProvider = queries.unregisterProvider;
export const requestPlanQuery = queries.request;
export const getPlanQueryStatus = queries.status;
export const hitTestModelPlan = queries.hitTest;
export const collectModelPlanBox = queries.boxSelect;
export const nearestModelPlanSnap = queries.nearestSnap;
export const isModelPlanQueryCurrent = queries.isCurrent;
